import React from 'react';
import '../../styles/profile.css';

const ProfessionalReviewDisplay = ({
  review,
  specialistName,
  specialistAvatarUrl,
  specialistInitials,
  statusLabel,
}) => {
  const data = review || {
    resumen: '',
    formacion: [],
    experiencia: [],
    publicada: false,
  };

  const avatarUrl = specialistAvatarUrl || data.avatar_url || null;
  const displayName = specialistName || data.especialista_nombre || '';
  const initials = specialistInitials || (displayName ? displayName.slice(0, 2).toUpperCase() : '');

  const hasContent =
    Boolean(data.resumen && data.resumen.trim()) ||
    (Array.isArray(data.formacion) && data.formacion.length > 0) ||
    (Array.isArray(data.experiencia) && data.experiencia.length > 0);

  if (!hasContent) {
    return <p className="profile-review-empty">Este especialista aún no ha registrado su reseña profesional.</p>;
  }

  return (
    <div className="profile-review-display">
      {displayName || avatarUrl || initials ? (
        <div className="profile-review-display-header">
          <span
            className="profile-review-display-avatar"
            style={avatarUrl ? { backgroundImage: `url(${avatarUrl})` } : undefined}
            aria-hidden={Boolean(avatarUrl)}
          >
            {!avatarUrl ? initials : null}
          </span>
          <div className="profile-review-display-meta">
            {displayName ? <p className="profile-review-display-name">{displayName}</p> : null}
            {statusLabel ? <p className="profile-review-status">{statusLabel}</p> : null}
          </div>
        </div>
      ) : null}

      {data.resumen ? (
        <section className="profile-review-section">
          <h3 className="profile-review-section-title">Resumen profesional</h3>
          <p className="profile-review-text">{data.resumen}</p>
        </section>
      ) : null}

      {Array.isArray(data.formacion) && data.formacion.length > 0 ? (
        <section className="profile-review-section">
          <h3 className="profile-review-section-title">Formación</h3>
          <ul className="profile-review-list">
            {data.formacion.map((item, index) => (
              <li key={`formacion-${index}`} className="profile-review-list-item">
                <strong>{item.titulo || 'Sin título'}</strong>
                {item.institucion ? ` · ${item.institucion}` : ''}
                {item.anio ? ` (${item.anio})` : ''}
              </li>
            ))}
          </ul>
        </section>
      ) : null}

      {Array.isArray(data.experiencia) && data.experiencia.length > 0 ? (
        <section className="profile-review-section">
          <h3 className="profile-review-section-title">Experiencia</h3>
          <ul className="profile-review-list">
            {data.experiencia.map((item, index) => (
              <li key={`experiencia-${index}`} className="profile-review-list-item">
                <strong>{item.cargo || 'Sin cargo'}</strong>
                {item.lugar ? ` · ${item.lugar}` : ''}
                {item.periodo ? ` (${item.periodo})` : ''}
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </div>
  );
};

export default ProfessionalReviewDisplay;
